import api from '../../api'
import {normalize} from 'normalizr';
import { sendNotification } from "../../application.actions"
export const IRRS_RECEIVED = 'IRRS_RECEIVED';
export const IRRS_HOME_GRID_FILTER_CHANGED = 'IRRS_HOME_GRID_FILTER_CHANGED';
export const IRRS_HOME_GRID_SORT_CHANGED = 'IRRS_HOME_GRID_SORT_CHANGED';
export const IRRS_HOME_GRID_PAGINATION_CHANGED = 'IRRS_HOME_GRID_PAGINATION_CHANGED';
export const IRRS_GENERATED_IRR = 'IRRS_GENERATED_IRR';
export const IRRS_DELETED_IRR = 'IRRS_DELETED_IRR';

export const fetchIrrs = () => async (dispatch, getState) => {
    await api(dispatch).get('irrs', data => {

      return { type: IRRS_RECEIVED, payload: data };
    });
}

export const gridFilterChanged = (gridFilterModel) => ({
    type: IRRS_HOME_GRID_FILTER_CHANGED,
    payload: gridFilterModel.map(x => ({ ...x }))
  });
  
  export const gridSortChanged = (gridSortModel) => ({
    type: IRRS_HOME_GRID_SORT_CHANGED,
    payload: gridSortModel.map(x => ({ ...x }))
  });
  
  export const gridPaginationChanged = (currentPage) => ({
    type: IRRS_HOME_GRID_PAGINATION_CHANGED,
    payload: {
      currentPage: currentPage
    }
  });

  export const generateIrr = (periodId, body) => async (dispatch, getState) => {
    
    await api(dispatch).post(`irrs/${periodId}/generate`, body, response => [
      fetchIrrs(),
      {type: IRRS_GENERATED_IRR, payload: response},
      sendNotification('IRR Generated.')
  ]);
  };

  export const deleteIrr = (irrId, periodId) => async (dispatch, getState) => {
    const body = {
      irrId
    }
    await api(dispatch).delete(`irrs/${periodId}/${irrId}`, body, response => [
      {type: IRRS_DELETED_IRR, payload: (() => ({ ...response, id: irrId }))()},
      sendNotification('IRR DELETED.')
  ]);
  };


// WEBPACK FOOTER //
// ./src/modules/irr/irr.actions.js